import React from 'react';
import { Menu, Typography, Col, Row } from 'antd';
import { MailOutlined, DownloadOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TemplateDocumentButton } from '../../../../components/TemplateDocumentButton/TemplateDocumentButton';

const { Text } = Typography;

export const ExplanatoryDocumentMenu = ({
  owner,
  setIsEmailModalOpen,
  setTemplateType,
  setDocumentType
}) => {
  const { t } = useTranslation();

  return (
    <Menu>
      <Menu.Item
        key={owner._id}
        onClick={() => {
          setIsEmailModalOpen(true);
          setTemplateType('SEND_EXPLANATORY_DOCUMENT');
          setDocumentType('OWNER_EXPLANATORY_WITHOUT_NAME');
        }}
      >
        <Row gutter={10}>
          <Col>
            <MailOutlined />
          </Col>
          <Col>
            <Text>{t('owners.show.buttons.send_mail')}</Text>
          </Col>
        </Row>
      </Menu.Item>

      <TemplateDocumentButton
        parameters={[
          {
            collection: 'Owner',
            documentId: owner._id
          }
        ]}
        use_case="OWNER_EXPLANATORY_DOCUMENT"
        icon={<DownloadOutlined />}
        withIcon
        buttonType="link"
        button_text="owners.show.buttons.dl_doc"
        downloadName={t(
          'template-documents.form.OWNER_EXPLANATORY_DOCUMENT_FILENAME',
          {
            owner_name: `${owner.last_name} ${owner.first_name}`
          }
        )}
        fromMenu
        menuKey={`dl${owner._id}`}
      />
    </Menu>
  );
};

ExplanatoryDocumentMenu.propTypes = {
  owner: PropTypes.shape({
    _id: PropTypes.string,
    type: PropTypes.string,
    number: PropTypes.number,
    last_name: PropTypes.string,
    first_name: PropTypes.string
  }),
  setIsEmailModalOpen: PropTypes.func,
  setTemplateType: PropTypes.func,
  setDocumentType: PropTypes.func
};

ExplanatoryDocumentMenu.defaultProps = {
  owner: {},
  setIsEmailModalOpen: () => {},
  setTemplateType: () => {},
  setDocumentType: () => {}
};
